// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

// --- Cache del manifest en memoria (1 sola descarga por sesión) ---
let manifestPromise: Promise<Record<string, string>> | null = null;

function getManifest(): Promise<Record<string, string>> {
  if (!manifestPromise) {
    manifestPromise = fetch(`${import.meta.env.BASE_URL}locales-manifest.json`, {
      cache: 'no-store',
    })
      .then((res) => {
        if (!res.ok) throw new Error(`No se pudo cargar locales-manifest.json`);
        return res.json();
      });
  }
  return manifestPromise;
}

// Backend que usa el manifest hasheado en build/preview/prod
const manifestBackend = {
  type: "backend" as const,
  read: async (
    language: string,
    namespace: string,
    callback: (err: Error | null, data: any) => void
  ) => {
    try {
      const manifest = await getManifest();
      const key = `${language}/${namespace}`;
      const file = manifest[key];
      if (!file) return callback(new Error(`No se encontró en manifest: ${key}`), false);

      const res = await fetch(`${import.meta.env.BASE_URL}${file}`);
      if (!res.ok) throw new Error(res.statusText);

      const data = await res.json();
      callback(null, data);
    } catch (err) {
      callback(err as Error, false);
    }
  },
};

// En dev usamos http-backend directo desde /public/locales
const backendToUse = import.meta.env.DEV ? Backend : manifestBackend;

i18n
  .use(backendToUse)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.DEV,
    ns: [
      "translation",
      "OrdersPage",
      "FieldName",
      "CommonButtons",
      "Backend",
      "NewOrder",
      "Notifications",
      "Labels",
      "MenuOptions",
      "LoginPage",
      "SubscribePage",
    ],
    defaultNS: "translation",
    lng: 'es',             // initial language
    fallbackLng: "es",
    load: "languageOnly",
    interpolation: { escapeValue: false },
    backend: import.meta.env.DEV
      ? { loadPath: "/locales/{{lng}}/{{ns}}.json" }
      : undefined,
  });

export default i18n;
